import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[zefSelectContainer]',
  standalone: false,
})
export class SelectContainer {
  readonly tr = inject<TemplateRef<any>>(TemplateRef);
}
